var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickbooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 53.9237C41.9119 53.9237 54 41.8526 54 26.9618C54 12.0711 41.9119 0 27 0C12.0881 0 0 12.0711 0 26.9618C0 41.8526 12.0881 53.9237 27 53.9237Z",
    fill: "#2CA01C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 16.4765C12.198 16.4765 7.50024 21.1737 7.50024 26.9614C7.50024 32.749 12.198 37.4462 17.9999 37.4462H19.4996V33.5522H17.9999C14.3577 33.5522 11.3998 30.5984 11.3998 26.9614C11.3998 23.3243 14.3577 20.3705 17.9999 20.3705H21.6058V40.7416C21.6058 42.8922 23.3517 44.6356 25.5053 44.6356V16.4765H17.9989H17.9999ZM36.006 37.4462C41.8078 37.4462 46.5056 32.749 46.5056 26.9614C46.5056 21.1737 41.8078 16.4765 36.006 16.4765H34.5063V20.3716H36.006C39.6481 20.3716 42.6061 23.3253 42.6061 26.9624C42.6061 30.5994 39.6481 33.5532 36.006 33.5532H32.4001V13.1811C32.4001 11.0305 30.6542 9.28711 28.5006 9.28711V37.4462H36.007H36.006Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickbooks);
export default __webpack_public_path__ + "static/media/Quickbooks.debe9a78d63a05d8f7d5b691ec2440d6.svg";
export { ForwardRef as ReactComponent };